import { render, staticRenderFns } from "./UiCounter.vue?vue&type=template&id=0fb3bd0a&"
import script from "./UiCounter.vue?vue&type=script&lang=js&"
export * from "./UiCounter.vue?vue&type=script&lang=js&"
import style0 from "./UiCounter.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
